import { Component, Input, OnInit } from '@angular/core';
import { Race } from 'src/app/models/race';

@Component({
  selector: "app-races-info",
  templateUrl: "./races-info.component.html",
  styleUrls: ["./races-info.component.scss"],
})
export class RacesInfoComponent implements OnInit {
  @Input() selectedRace!: Race;

  constructor() {}

  ngOnInit() {    
  }
}
